import { ref } from "vue";
import { defineStore } from "pinia";
import { themeService } from '../theme-service';

export const useThemeStore = defineStore("theme", () => {
  const theme = ref("light");

  const toggleTheme = (_theme) => {
    themeService.currentTheme.value = theme.value;
    if (_theme) {
      theme.value = _theme;
    } else {
      theme.value = theme.value === 'light' ? 'dark' : 'light';
    }
    themeService.switchAppTheme();
  };

  return { theme, toggleTheme };
},
{
  persist: true,
});
